import React, { useState } from "react";
import { BiChevronLeft } from "react-icons/bi";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { useNavigate } from "react-router";
import { addShippingAddress, getShippingAddress, updateShippingAddress } from "../../api/ship";
import { showErrorToast, showSuccessToast } from "../../utils/toast";

const boxShadowStyle = {
  boxShadow: "0px 2px 9px 0px #00000008",
  userSelect: "none",
};

const ShippingAddresses = () => {
  const navigate = useNavigate();
  const queryClient = useQueryClient();

  const [editAddress, setEditAddress] = useState(null);

  const { data } = useQuery("shipping-address", getShippingAddress);

  const mutation = useMutation(editAddress ? updateShippingAddress : addShippingAddress, {
    onError: (e) => {
      showErrorToast(e.message);
    },
  });

  const onFinish = (e) => {
    e.preventDefault();
    const formData = new FormData(e.target);
    const line1 = formData.get("line1");
    const line2 = formData.get("line2");
    const state = formData.get("state");
    const country = formData.get("country");
    const city = formData.get("city");
    const zipCode = formData.get("zipCode");

    mutation.mutate(
      {
        ...(editAddress && { id: editAddress._id }),
        line1,
        line2,
        state,
        country,
        city,
        zipCode,
      },
      {
        onSuccess: () => {
          e.target.reset();
          setEditAddress(null);
          showSuccessToast("Added successfully");
          queryClient.invalidateQueries("shipping-address");
        },
      }
    );
  };

  return (
    <div className="p-5 font-dmsans">
      <div className="flex flex-col gap-5 mb-16">
        <div className="flex items-center gap-3">
          <BiChevronLeft
            className="text-[#070E05] text-[25px] cursor-pointer"
            onClick={(e) => {
              navigate(`/shipping`);
            }}
          />
          <div className=" font-Neurial font-bold text-[20px] text-[#070E05]">
            All Shipping Address
          </div>
        </div>
        <div className="flex gap-10">
          <div
            className="w-1/3 p-3 h-fit bg-white rounded-lg"
            style={boxShadowStyle}
          >
            <div className="w-full">
              {(data || []).map((v, k) => {
                return (
                  <div
                    className="my-1 p-3 flex items-center gap-2 rounded-lg cursor-pointer"
                    key={k}
                    onClick={(e) => {}}
                  >
                    <div>
                      <p className="text-[#333333] font-Neurial text-[14px]">
                        {v.line1}
                      </p>
                      <p>{v.country}</p>
                    </div>
                    <button className="ml-auto text-[#2F66F6] font-medium text-[13px]"
                    onClick={() => setEditAddress(v)}
                    >
                      Edit
                    </button>
                  </div>
                );
              })}
            </div>
          </div>
          <div
            className="w-2/3 py-12 flex flex-col justify-center items-center bg-white rounded-lg"
            style={boxShadowStyle}
          >
            <form className="space-y-7 font-Neurial w-2/3" onSubmit={onFinish}>
              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">Line 1</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="line1"
                  defaultValue={editAddress?.line1}
                />
              </div>

              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">Line 2</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="line2"
                  defaultValue={editAddress?.line2}
                />
              </div>

              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">City</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="city"
                  defaultValue={editAddress?.city}
                />
              </div>

              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">State</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="state"
                  defaultValue={editAddress?.state}
                />
              </div>

              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">Zip Code</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="zipCode"
                  defaultValue={editAddress?.zipCode}
                />
              </div>

              <div className="space-y-2">
                <div className="text-[15px] text-[#181819E5]">Country</div>
                <input
                  className="w-full py-2 px-3 border-[#E6E7E9] border-[1px] rounded-lg disabled:bg-white"
                  name="country"
                  defaultValue={editAddress?.country}
                />
              </div>

              <div className="flex w-full gap-5">
                <button
                  type="submit"
                  className={`w-full bg-dark p-3 rounded-[5px] font-bold text-white ${
                    mutation.isLoading ? "animate-pulse" : ""
                  }`}
                >
                  {mutation.isLoading ? "Saving..." : "Save changes"}
                </button>
                <button
                  type="button"
                  className="cursor-pointer w-full bg-[#0000000D] p-3 rounded-[5px] font-bold text-dark"
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ShippingAddresses;
